import React from 'react';
import { cardGeometry } from './wallCardGeometry';
import './wallCardLoading.css';

/** The current borderless card, not the retired status-strip/action-toolbar card. */
export default function WallCardSkeleton({ width = 600, ratio, overlay = false, geometry = null }) {
  const card = cardGeometry(ratio, width);
  const side = geometry ? geometry.dir === 'row' : card.side;
  return <div aria-hidden="true" data-masonry-placeholder data-testid="wall-card-skeleton" data-layout={side ? 'side' : 'stacked'}
    className={`wall-card-skeleton ${overlay ? 'wall-card-skeleton-overlay' : ''}`}
    style={{
      gridTemplateColumns: side ? (geometry ? `${geometry.imgW}px minmax(0,1fr)` : 'minmax(0,44fr) minmax(0,56fr)') : 'minmax(0,1fr)',
      gridTemplateRows: side ? undefined : `${geometry ? geometry.imgH : width / card.aspect}px minmax(0,1fr)`,
    }}>
    <div className="wall-skeleton-poster" style={geometry ? { height: geometry.imgH } : { aspectRatio: String(card.aspect) }}>
      <span className="wall-skeleton-tag" />
    </div>
    <div className="wall-skeleton-body" style={{ padding: geometry ? '20px 22px 22px' : side ? 24 : '22px 24px 24px' }}>
      <span className="wall-skeleton-bar" style={{ width: '68%', height: 12 }} />
      <span className="wall-skeleton-bar" style={{ width: '94%', height: width > 520 ? 26 : 22 }} />
      <span className="wall-skeleton-bar" style={{ width: '72%', height: width > 520 ? 26 : 22 }} />
      <span className="wall-skeleton-bar" style={{ width: '56%', height: 11 }} />
      <div className="wall-skeleton-footer"><span className="wall-skeleton-bar" style={{ width: 70, height: 18 }} /><span className="wall-skeleton-bar" style={{ width: 122, height: 40 }} /></div>
    </div>
  </div>;
}
